import { useState } from 'react';

export const useFieldValidation = (initialErrors = {}) => {
  const [errors, setErrors] = useState(initialErrors);

  const setFieldError = (rowId, field, errorMsg) => {
    setErrors((prevErrors) => {
      const rowErrors = prevErrors[rowId] || {};
      if (errorMsg) {
        return { ...prevErrors, [rowId]: { ...rowErrors, [field]: errorMsg } };
      } else {
        // Remove field error. Remove row if no fields left.
        const { [field]: _removed, ...rest } = rowErrors;
        if (Object.keys(rest).length === 0) {
          const { [rowId]: _rowRemoved, ...remaining } = prevErrors;
          return remaining;
        }
        return { ...prevErrors, [rowId]: rest };
      }
    });
  };

  return { errors, setFieldError, setErrors };
};
